import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { Heat } from "@/common/model/Heat";
import { EventUser } from "@/common/model/User";

type ConfirmationUserDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (passedUser: EventUser) => void;
  eventUser: EventUser;
};

function ConfirmationUserDialog({
  open,
  onClose,
  onConfirm,
  eventUser,
}: ConfirmationUserDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Deletion of: {eventUser.displayname}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this item? This action cannot be
          undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "blue",
            "&:hover": { backgroundColor: "darkblue" },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm(eventUser);
            onClose();
          }}
          variant="contained"
          sx={{
            backgroundColor: "red",
            "&:hover": { backgroundColor: "darkblue" },
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationUserDialog;
